<div class="flex-control flex-column programs-module">
  <app-tabs>
    <li (click)="tabsService.deactivate_tab()" [class.active]="!tabsService.is_active()">Intake Forms Templates</li>
  </app-tabs>
  <app-intake-form-templates class="flex-control flex-column" [hidden]="tabsService.is_active()"></app-intake-form-templates>
</div>
